// extracted by mini-css-extract-plugin
export var copyableField = "_r2-4";
export var customerBadge = "_r2-0";
export var customerInfoTitle = "_r2-2";
export var details = "_r2-1";
export var dropdownContainer = "_r2-5";
export var dropdownImage = "_r2-6";
export var editAssigneeForm = "_r2-a";
export var editButton = "_r2-3";
export var email = "_r2-7";
export var hidden = "_r2-d";
export var input = "_r2-8";
export var saveButton = "_r2-b";
export var shopifyIcon = "_r2-c";
export var suggestionBadge = "_r2-e";
export var suggestionText = "_r2-f";
export var username = "_r2-9";